import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const DarjeelingPackage = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/darjeeling.jpeg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Darjeeling Himalayan Escape</h1>

            <p className="hero-subtitle">
              3 Nights / 4 Days • Queen of Hills Tour
            </p>

            <div className="hero-price">
              Starting From <span>₹18,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/darjeeling.jpeg" alt="" />
                <img src="/Images/tour/darjeeling1.jpeg" alt="" />
                <img src="/Images/tour/darjeeling2.webp" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹18,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>
        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Darjeeling Himalayan Escape</h1>
              <p>3 Nights / 4 Days • Scenic Hill Station Tour</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Tiger Hill Sunrise View</Col>
                <Col md={6}>✔ Darjeeling Himalayan Railway</Col>
                <Col md={6}>✔ Tea Garden Visit</Col>
                <Col md={6}>✔ Batasia Loop & War Memorial</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Discover the charm of Darjeeling, known as the Queen of
                Hills. Enjoy breathtaking views of Kanchenjunga,
                colonial heritage, tea gardens, toy train rides and
                peaceful Himalayan landscapes.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Darjeeling
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival at Bagdogra/NJP and transfer to Darjeeling.
                    Evening free at Mall Road.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Local Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Early morning Tiger Hill sunrise followed by visits
                    to Batasia Loop, Ghoom Monastery, Tea Garden and
                    Himalayan Mountaineering Institute.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Leisure & Exploration
                  </Accordion.Header>
                  <Accordion.Body>
                    Explore local markets, optional toy train ride and
                    enjoy panoramic Himalayan views.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Day 4 – Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    Breakfast and transfer to Bagdogra/NJP for onward
                    journey.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion / Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Daily Breakfast</li>
                    <li>Private Transfers</li>
                    <li>Sightseeing Tours</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Airfare / Train Fare</li>
                    <li>Personal Expenses</li>
                    <li>Entry Tickets</li>
                    <li>Adventure Activities</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/darjeeling.jpeg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/darjeeling1.jpeg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/darjeeling2.webp" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default DarjeelingPackage;